export const RESET_NIR_AND_EXEMPTION_STORE = "RESET_NIR_AND_EXEMPTION_STORE"
